import { render, staticRenderFns } from "./allCompetitionPartnerList.vue?vue&type=template&id=4a4fea71&scoped=true"
import script from "./allCompetitionPartnerList.vue?vue&type=script&lang=ts"
export * from "./allCompetitionPartnerList.vue?vue&type=script&lang=ts"
import style0 from "./allCompetitionPartnerList.vue?vue&type=style&index=0&id=4a4fea71&prod&scoped=true&lang=stylus"
import style1 from "./allCompetitionPartnerList.vue?vue&type=style&index=1&id=4a4fea71&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4fea71",
  null
  
)

export default component.exports